import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const getParcelBoxLabel = {
  name: "getParcelBoxLabel" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    parcelIndex: z.number().int().nonnegative(),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
  }),
  output: z.object({ url: z.string() }),
};
